<template>
  <!-- template have only one root node -->
  <div class="component">
    <div class="navBar">
      <div class="navBarContent">
        <div class="leftContent">
          <img @click="back()" :src="backUrl" class="back" />
          <div :class="`navTip ${isNight ? 'navTip_dark' : ''}`" v-if="showTip">
            {{ navTip || 'navTip' }}
          </div>
        </div>
        <div class="rightContent" v-if="showRightTip">
          <div class="rightText" @click="enterChange">{{rightTip}}</div>
        </div>
      </div>
    </div>
    <div class="spaceSep" v-if="false"></div>
  </div>
</template>
<style scoped>
.component {
  position: relative;
  z-index: 10;
  flex-direction: column;
}
.navBar {
  display: flex;
  /* margin-left: 18px; */
  padding: 0.120012rem 0.33rem;
  align-items: center;
  flex-direction: row;
}
.navBarContent {
  flex: 1;
  display: flex;
  align-items: center;
  height:1.26rem;
}
.navBar .leftContent .back {
  width: 0.72rem;
  height: 0.72rem;
  padding:0.27rem;
}
.leftContent{
  /* width:6.006rem; */
  display:flex;
  align-items:center

}
.rightContent {
  width:100%;
  flex:1;
  height:1.26rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.rightText {
  height:0.6rem;
  line-height: 0.6rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.42rem;
  margin-right: 0.27rem;
}
.navTip {
  margin-left: 0.18rem;
  padding-right: calc(100px / 3);
  text-overflow: ellipsis;
  font-size: 16px;
  color:rgba(0, 0, 0, 0.85);
}
.navTip_dark {
  color: rgba(255, 255, 255, 0.85)
}
.spaceSep {
  width: 312px;
  height: calc(10px / 3);
  margin-left: 72px;
  background-color: rgba(0, 0, 0, 0.06);
}
.rightCotnent {
  padding-right: 20px;
}
.rightCotnent .bubbleWrap {
  display: flex;
  align-items: center;
  position: absolute;
  right: 56px;
  top: 0;
  font-size: 12px;
  padding: 7px 10px;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.55);
  border: calc(1px / 3) solid rgba(0, 0, 0, 0.1);
  border-radius: calc(26px / 3);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
}
.rightCotnent .bubbleWrap_dark {
  background: #404040;
  color: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.08);
}
.rightCotnent .bubbleWrap .rightBorder {
  position: absolute;
  width: 0;
  height: 0;
  border: 10px solid;
  border-color: transparent;
  border-left-color: #ffffff;
  right: -16px;
}
.rightCotnent .bubbleWrap_dark .rightBorder {
  border-left-color: #404040;
}
.rightCotnent .bubbleWrap .tipIcon {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}
</style>
<script>
import backPng from './images/back.webp'
import blackBackPng from './images/back_block.webp'
import tipIcon from './images/tip.png'
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'

export default {
  props: [
    'navTip',
    'showSep',
    'showTip',
    'showRightTip',
    'showShare',
    'isDetail',
    'rightTip',
    'showBubble',
    'isNight',
  ],
  data() {
    return {
      tipIcon
    }
  },
  computed: {
    backUrl() {
      if(this.isDetail){
        return backPng
      } 
     if(this.isNight){
        return backPng
      }
      else {
        return blackBackPng
      }  
    }
  },
  methods: {
    back() {
      if (this.$route.name == 'home' && JsBridge.getEnv() == 'gameHall') {
        // 调用apk back方法
        window.android.closePage()
      }else{
        this.$router.back() 
      }
    },
    enterChange() {
      this.$emit('enterCode')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/head_nav/index.vue